<app-list-billing 
    [chunkBookingBilling]="chunkBookingBilling" 
    [guideBillingStats]="guideBillingStats"
    [guideNames]="guides" 
    [isProvider]="true" 
    [isGuideBilling]="true" 
    (findBillingTrigger)="onFindBillingTrigger($event)">
</app-list-billing>
<app-message-panel [preloading]="true"></app-message-panel>